"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue } from "vue-property-decorator";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import API from "@ym-framework/api-utils";
import _ from "lodash";
import DistributionDialog from "@/components/dialog/DistributionDialog.vue";
import { APIDataSource } from "@/components/grid/data-source";
let VdBindShop = class extends Vue {
  constructor() {
    super(...arguments);
    // base.auth.pro
    // 店铺列表
    this.gridController = new GridController(new APIDataSource("api://base.auth.pro/v1/shops"));
    // gridController = new GridController<VirtualdesktopModel>(new APIDataSource("api://base.auth/api/v7/groups/shop_list"));
    this.selectDatas = [];
    this.selectLock = false;
    this.activeName = "unbind";
    this.searchStr = "";
    this.vdId = "";
    this.searchByName = _.debounce((searchStr) => __async(this, null, function* () {
      yield this.realSearchName(searchStr);
    }), 500);
  }
  created() {
    this.gridController.on("searched", (item) => {
      this.checkItem();
    });
    this.gridController.pagePosition = "dialog";
    this.gridController.size = true;
  }
  mounted() {
  }
  open(id, selectDatas = []) {
    this.vdId = id;
    this.searchStr = "";
    this.selectDatas = [];
    this.selectLock = false;
    this.activeName = "unbind";
    this.gridController.query.params = {
      search: `status == 'NOT_BIND_VD'`,
      type: "VD_BIND"
    };
    this.gridController.search();
    this._distributionDialog.open();
    this.$nextTick(() => {
      for (const item of selectDatas) {
        this._distributionDialog.add(item);
      }
    });
  }
  saved(data) {
    return __async(this, null, function* () {
      let shopIds = [];
      for (const item of data) {
        shopIds.push(item.id);
      }
      try {
        const bind_response = yield API.post(`api://base.auth.pro/v1/virtual-desktops/${this.vdId}/shops-ebusiness-repeat`, {
          "model": "shop.bind",
          "type": "override",
          "shopIds": shopIds
        });
        if (bind_response.data.datas && bind_response.data.datas.length > 0) {
          let message = "";
          for (const ebusinessItem of bind_response.data.datas) {
            if (ebusinessItem.total !== 0) {
              message += `${this.$t("vdbindshop.bind_shop_confirm_tip", { "num": ebusinessItem.total, "custom": ebusinessItem.ebusinessName })}`;
            }
          }
          if (message !== "") {
            message = message + `${this.$t(`vdbindshop.bind_shop_confirm_bind_shop`)}`;
            try {
              yield this.$confirm(
                message,
                this.$t("vdbindshop.binding_shop_confirm_title"),
                {
                  roundButton: true,
                  cancelButtonText: `${this.$t("vdbindshop.binding_tip_cancel")}`,
                  confirmButtonText: `${this.$t("vdbindshop.binding_tip_confirm")}`
                }
              );
            } catch (error) {
              return;
            }
          }
        }
        yield API.post(`api://base.auth.pro/v1/virtual-desktops/${this.vdId}/shops`, {
          shopIds,
          mode: "OVERRIDE"
        });
        this.$message.success(this.$t("vdbindshop.binding_successful"));
        this._distributionDialog.close();
        this.$emit("refresh");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  selectItems(items) {
    this.selectDatas = [];
    this.selectDatas = items;
    if (!this.selectLock) {
      let _tmp = _.filter(this.selectDatas, (data) => {
        return data.vdId !== "" && data.vdId !== null && data.vdId !== this.vdId;
      });
      if (_tmp.length > 0) {
        this.$confirm(this.$t("vdbindshop.the_selected_store_is_bound_to_another"), this.$t("vdbindshop.tips"), {
          confirmButtonText: this.$t("vdbindshop.determine"),
          cancelButtonText: this.$t("vdbindshop.cancel"),
          type: "warning"
        }).then(() => {
          this._distributionDialog.syncData(this.gridController.result.datas, items, "id", "name");
        }).catch(() => {
          this.checkItem();
        });
      } else {
        this._distributionDialog.syncData(this.gridController.result.datas, items, "id", "name");
      }
    }
  }
  changed(data) {
    let rows = _.differenceWith(this.selectDatas, data, (selectData, data2) => selectData.id == data2.id);
    this.selectLock = true;
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, false);
      }
    }
    this.selectLock = false;
  }
  checkItem() {
    let selectDatas = this._distributionDialog.getAll();
    let rows = _.intersectionWith(this.gridController.result.datas, selectDatas, (selectData, data) => selectData.id == data.id);
    this.selectLock = true;
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, true);
      }
    }
    this.selectLock = false;
  }
  realSearchName(searchStr) {
    return __async(this, null, function* () {
      if (searchStr !== null && searchStr !== "") {
        if (this.activeName === "all") {
          this.gridController.query.params = {
            search: `name=like='${searchStr}'`,
            type: "VD_BIND"
          };
        }
        if (this.activeName === "unbind") {
          this.gridController.query.params = {
            search: `status == 'NOT_BIND_VD';name=like='${searchStr}'`,
            type: "VD_BIND"
          };
        }
      }
      if (searchStr === null || searchStr === "") {
        if (this.activeName === "all") {
          this.gridController.query.params = {
            search: "",
            type: "VD_BIND"
          };
        }
        if (this.activeName === "unbind") {
          this.gridController.query.params = {
            search: `status == 'NOT_BIND_VD'`,
            type: "VD_BIND"
          };
        }
      }
      this.gridController.query.current = 1;
      yield this.gridController.search();
    });
  }
  handleClick(tab, event) {
    if (this.searchStr !== null && this.searchStr !== "") {
      if (this.activeName === "all") {
        this.gridController.query.params = {
          search: `name=like='${this.searchStr}'`,
          type: "VD_BIND"
        };
      }
      if (this.activeName === "unbind") {
        this.gridController.query.params = {
          search: `status == 'NOT_BIND_VD';name=like='${this.searchStr}'`,
          type: "VD_BIND"
        };
      }
    }
    if (this.searchStr === null || this.searchStr === "") {
      if (tab.name === "all") {
        this.activeName = "all";
        this.gridController.query.params = {
          search: "",
          type: "VD_BIND"
        };
      }
      if (tab.name === "unbind") {
        this.activeName = "unbind";
        this.gridController.query.params = {
          search: `status == 'NOT_BIND_VD'`,
          type: "VD_BIND"
        };
      }
    }
    this.gridController.query.current = 1;
    this.gridController.search();
  }
};
__decorateClass([
  Ref("distributionDialog")
], VdBindShop.prototype, "_distributionDialog", 2);
__decorateClass([
  Ref("multipleTable")
], VdBindShop.prototype, "_multipleTable", 2);
VdBindShop = __decorateClass([
  Component({
    components: {
      UiGrid,
      DistributionDialog
    }
  })
], VdBindShop);
export {
  VdBindShop as default
};
